import {
  combineReducers
} from 'redux';
import {
  reducer as formReducer
} from 'redux-form';
import configReducer from './config';
import coverageReducer from './coverage';
import entitiesReducer from './entities';
import metaReducer from './meta';

export default combineReducers({
  config: configReducer,
  coverage: coverageReducer,
  entities: entitiesReducer,
  form: formReducer,
  meta: metaReducer,
});


// WEBPACK FOOTER //
// ./src/reducers/index.js